"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const styles_1 = __importDefault(require("../../styles/styles"));
const icon_1 = __importDefault(require("../icon/icon"));
const messageComponentStyles_1 = __importDefault(require("./messageComponentStyles"));
const PaginatedMessageComponent = ({ message, color, icon, }) => (react_1.default.createElement(react_native_1.View, { style: styles_1.default.boxStyles },
    react_1.default.createElement(react_native_1.View, { style: [
            styles_1.default.centerChilds,
            styles_1.default.flexDirectionColumn,
            styles_1.default.minHeight,
            styles_1.default.alignCenterCenter,
        ] },
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
            react_1.default.createElement(icon_1.default, { icon: icon, color: color, size: 140 })),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
            react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlack, messageComponentStyles_1.default.text] }, message)))));
exports.default = PaginatedMessageComponent;
